import { render, staticRenderFns } from "./products.view.vue?vue&type=template&id=0e1804f6&"
import script from "./products.view.vue?vue&type=script&lang=js&"
export * from "./products.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports